import { Link, useNavigate } from "@tanstack/react-router";
import { Lock01 } from "@untitledui/icons";
import { EmptyState } from "@/components/application/empty-state/empty-state";
import { Button } from "@/components/base/buttons/button";
import { useMerchant } from "@/providers/MerchantProvider";

/** Shown in place of a workspace/team page's content when the signed-in user isn't a
 *  Workspace Admin of that workspace — including when the workspace doesn't exist at
 *  all, which resolves to the same `workspace: undefined` state (UNB-2694). Rendered
 *  inside `WorkspaceLayout`, so the sidebar/nav chrome stays up. */
export const WorkspaceNoAccessState = () => {
  const navigate = useNavigate();
  // Team settings has no workspace-level page reachable without workspace access
  // itself (only per-merchant, `/merchant/$merchantId/settings/team`) — points at
  // whichever merchant the user was last on.
  const merchantId = useMerchant();

  return (
    <div className="flex h-full w-full items-center justify-center">
      <EmptyState size="md">
        <div className="pb-6">
          <EmptyState.FeaturedIcon icon={Lock01} color="gray" />
        </div>
        <EmptyState.Content>
          <EmptyState.Title>You don't have access to this workspace</EmptyState.Title>
          <EmptyState.Description>
            Ask a Workspace Admin to give you access. You can see who your admins are in{" "}
            <Link
              to="/merchant/$merchantId/settings/team"
              params={{ merchantId }}
              className="text-brand-secondary hover:underline"
            >
              Settings › Teams
            </Link>
            , look for anyone with the "Workspace Admin" role.
          </EmptyState.Description>
        </EmptyState.Content>
        <EmptyState.Footer>
          <Button color="primary" size="md" onClick={() => navigate({ to: "/" })}>
            Go to home
          </Button>
        </EmptyState.Footer>
      </EmptyState>
    </div>
  );
};
